import { useMutation } from "react-query";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deleteDCompany = ({ dCompanyId }: { dCompanyId: number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/DCompanies/DeleteDCompany/${dCompanyId}`);
};

type QueryFnType = typeof deleteDCompany;

type UseDeleteDCompanyOptions = {
  dCompanyId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeleteDCompany = ({ config }: UseDeleteDCompanyOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: any) => {
      addNotification(`Υπήρξε κάποιο πρόβλημα στην διαγραφή της Θυγατρικής.`, 500);
      console.error("Couldnt delete DCompany", error);
      setIsNotificationVisible(true);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllDCompanies"]);
      addNotification(`Η Θυγατρική Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deleteDCompany,
  });
};
